module.exports = __webpack_public_path__ + "static/img/background.9b732b81.png";